import * as $ from "jquery";

export function activateTeaserEqualHeight() {
    function adjustDescriptionHeight() {
        $('.ce-teaserbox-pages').each(function() {
            const $descriptions = $(this).find('.box-bottom .description p');
            
            $descriptions.height('auto');
            
            if ($(window).width() > 575) {
                let maxHeight = 0;
                
                $descriptions.each(function() {
                    const height = $(this).outerHeight();
                    maxHeight = Math.max(maxHeight, height);
                });
                
                $descriptions.height(maxHeight);
            }
        });

        const $allHeaders = $('a.box-special .header-outer');
        $allHeaders.height('auto');
        
        if ($(window).width() > 575) {
            let maxHeaderHeight = 0;
            
            $allHeaders.each(function() {
                const $firstChild = $(this).children().first();
                const $lastChild = $(this).children().last();
                const height = $firstChild.outerHeight() + $lastChild.outerHeight();
                maxHeaderHeight = Math.max(maxHeaderHeight, height);
            });
            
            $allHeaders.height(maxHeaderHeight);
        }
    }

    $(document).ready(function() {
        adjustDescriptionHeight();
    });

    $(window).on('resize', function() {
        adjustDescriptionHeight();
    });
}
